import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/logo.svg';
const _withScopeId = n => (_pushScopeId("data-v-095d604d"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "header view-container"
};
const _hoisted_2 = {
  class: "view-content"
};
const _hoisted_3 = {
  class: "leftBox"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "康信通",
  src: _imports_0,
  height: "32"
}, null, -1));
const _hoisted_5 = {
  class: "rightBox"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://m.kangxt.com/",
  target: "_blank"
}, "登录", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link");
  const _component_el_menu_item = _resolveComponent("el-menu-item");
  const _component_el_sub_menu = _resolveComponent("el-sub-menu");
  const _component_el_menu = _resolveComponent("el-menu");
  const _component_el_button = _resolveComponent("el-button");
  const _component_FreeExperience = _resolveComponent("FreeExperience");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_router_link, {
    class: "logo",
    to: "/"
  }, {
    default: _withCtx(() => [_hoisted_4]),
    _: 1
  }), _createVNode(_component_el_menu, {
    class: "menuBox",
    mode: "horizontal",
    router: "",
    ellipsis: false,
    "default-active": $options.defaultActive
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.routes, (route, i) => {
      return _openBlock(), _createElementBlock(_Fragment, {
        key: i
      }, [route.children ? (_openBlock(), _createBlock(_component_el_sub_menu, {
        key: 0,
        index: route.path,
        "popper-class": "subMenuBox"
      }, {
        title: _withCtx(() => [_createTextVNode(_toDisplayString(route.name), 1)]),
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(route.children, (subRoute, j) => {
          return _openBlock(), _createBlock(_component_el_menu_item, {
            key: j,
            route: subRoute,
            index: route.path + '/' + subRoute.path
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(subRoute.name), 1)]),
            _: 2
          }, 1032, ["route", "index"]);
        }), 128))]),
        _: 2
      }, 1032, ["index"])) : (_openBlock(), _createBlock(_component_el_menu_item, {
        key: 1,
        route: route,
        index: route.path
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(route.name), 1)]),
        _: 2
      }, 1032, ["route", "index"]))], 64);
    }), 128))]),
    _: 1
  }, 8, ["default-active"])]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_button, {
    class: "login"
  }, {
    default: _withCtx(() => [_hoisted_6]),
    _: 1
  })])]), _createVNode(_component_FreeExperience, {
    visible: $data.visibleFreeExperience,
    onHide: _cache[0] || (_cache[0] = $event => $data.visibleFreeExperience = false)
  }, null, 8, ["visible"])]);
}